// extracted by mini-css-extract-plugin
export default {"formula":"w_Jwn nIEuB KL0Gm","formulaHeader":"D7fZn DeJoR uSVJz sIVwU","formulaTitle":"c7FYL AfLf3","formulaDefinitionInner":"uxB2L d1csx"};